import { formatDateToCustomDateFormat } from 'lib/utils/date';
import { DATE_TIME_FORMAT } from 'definitions/dates';

const ticketStatus = state => state.ticket?.status;

const ticketCode = state => state.ticket?.code;

const ticketCreatedAt = state => formatDateToCustomDateFormat(state.ticket?.createdAt, DATE_TIME_FORMAT);

const ticketLastShownAt = state => formatDateToCustomDateFormat(state.ticket?.lastShownAt, DATE_TIME_FORMAT);

const ticketDescription = state => state.ticket?.description;

const ticketName = state => state.ticket?.name;

const editableTicket = (state) => state.editableTicket;

export default {
  ticketStatus,
  ticketCode,
  ticketCreatedAt,
  ticketLastShownAt,
  ticketDescription,
  ticketName,
  editableTicket,
};
